import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion'
import './style/css/main.css'
import LandingPage from './pages/landingPage'
import About from './pages/About'
import Project from './pages/Project'
import Contact from './pages/Contact';
import ProjectDetail from './components/ProjectDetail';
import { useState } from 'react';

function App() {
  const [project, setProject] = useState({})
  const handleProjectPage = (data) => {
    setProject(data)
    if (!localStorage.getItem('projectData')) {
      localStorage.setItem('projectData', JSON.stringify(data))
    } else {
      localStorage.setItem('projectData', JSON.stringify(data))
    }
  }
  return (
    <BrowserRouter>
      <AnimatePresence mode='wait'>
        <Routes>
          <Route path='/' element={<LandingPage projectObj={handleProjectPage} />} key="landingPage" />
          <Route path='/about' element={<About />} key="about" />
          <Route path='/contact' element={<Contact />} key="contact" />
          <Route path='/project' element={<Project />} key="project" />
          <Route path='/project/:id' element={<ProjectDetail data={project} />} key="project-detail" />
        </Routes>
      </AnimatePresence>
    </BrowserRouter>
  );
}

export default App;
